import { useContext } from 'react';
import { ThemeContext } from './ThemeContext';

/**
 * 主題 Hook
 * 提供對主題狀態和切換功能的訪問
 */
export function useTheme() {
  const context = useContext(ThemeContext);
  
  if (context === undefined) {
    throw new Error('useTheme 必須在 ThemeProvider 內部使用');
  }
  
  return context;
}
